type ErrorStatus = {
    code: string;
    developerMessage: string;
};

type Error = Record<'errorStatus', ErrorStatus>;

export const isErrorType = (err): err is Error => !!err && typeof err === 'object' && 'errorStatus' in err;
